import { render, staticRenderFns } from "./shift-table-controls.vue?vue&type=template&id=2a317c15&scoped=true&"
import script from "./shift-table-controls.vue?vue&type=script&lang=js&"
export * from "./shift-table-controls.vue?vue&type=script&lang=js&"
import style0 from "./shift-table-controls.vue?vue&type=style&index=0&id=2a317c15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a317c15",
  null
  
)

export default component.exports